import React, { useState, useEffect } from "react";
import MainLayout from "../layout/MainLayout";
import Header from "../components/Header";
import { formatCurrency, months } from "../utils/utils";
import { LuPencilLine } from "react-icons/lu";
import Button from "../components/Button";
import ConfirmDialog from "../components/confirm-alert/ConfirmDialog ";
import { useDispatch, useSelector } from "react-redux";
import {
  addProgramYear,
  createProgram,
  deleteProgram,
  fetchPrograms,
  updateProgram,
  updateProgramYear,
} from "../redux/reducers/programsSlice";
import Loader from "../components/loader/loader";
import { getTution } from "../redux/reducers/tuitionSlice";
import UnPaidCheckout from "./UnPaidCheckout";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";

const StartTracker = ({ unPaid }) => {
  const dispatch = useDispatch();
  const { programs, loading, error } = useSelector(
    (state) => state.programs ?? []
  );
  const { userDetails } = useSelector((state) => state.auth);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showAddYearDialog, setShowAddYearDialog] = useState(false);
  const [programToDelete, setProgramToDelete] = useState(null);
  const [programToUpdate, setProgramToUpdate] = useState(null);
  const [updateYear, setUpdateYear] = useState(null);
  const [update, setUpdate] = useState(null);
  const [programForYear, setProgramForYear] = useState(null);
  const [programsData, setProgramData] = useState(programs ?? []);
  const { userId } = userDetails;

  useEffect(() => {
    // Assuming userId is available in some way, e.g., from props or context

    dispatch(fetchPrograms(userId));
    setProgramData(programs);
  }, [dispatch, userId]);

  useEffect(() => {
    setProgramData(programs);
  }, [programs]);

  const openModal = () => {
    setEditData(null); // Clear any existing edit data
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditData(null); // Clear edit data when closing
  };

  const handleEdit = (program) => {
    setEditData(program);
    setIsModalOpen(true);
  };

  const handleDelete = (program) => {
    setProgramToDelete(program);
    setShowDeleteDialog(true);
  };

  const confirmDelete = () => {
    dispatch(deleteProgram(programToDelete));
    setShowDeleteDialog(false);

    setTimeout(() => {
      dispatch(fetchPrograms(userId));
      dispatch(getTution(userId));
      setProgramToDelete(null);
    }, 1000);
  };

  const cancelDelete = () => {
    setProgramToDelete(null);
    setShowDeleteDialog(false);
  };

  //Add Year Alert
  const initiateAddYear = (programId) => {
    setProgramForYear(programId);
    setShowAddYearDialog(true);
  };

  const confirmAddYear = () => {
    const programId = {
      id: programForYear,
    };
    dispatch(addProgramYear(programId));
    setShowAddYearDialog(false);

    setTimeout(() => {
      dispatch(fetchPrograms(userId));
      setProgramForYear(null);
    }, 1000);
  };

  const cancelAddYear = () => {
    setProgramForYear(null);
    setShowAddYearDialog(false);
  };

  //Update Years Alert
  const handleUpdateModal = (programId, showUp) => {
    setProgramToUpdate(programId);
    const selectProgramYearToUpdate = programsData.filter(
      (program) => program._id === programId
    );
    const years = { years: selectProgramYearToUpdate[0].years };

    setUpdateYear(years);
    setUpdate(showUp);
  };

  const confirmUpdate = () => {
    const programYearData = {
      id: programToUpdate,
      years: updateYear.years, // Assuming updateYear is structured correctly
    };
    dispatch(updateProgramYear(programYearData));
    setUpdate(false);

    setTimeout(() => {
      dispatch(fetchPrograms(userId));
      setProgramToUpdate(null);
    }, 1000);
  };

  const cancelUpdate = () => {
    setUpdate(false);
  };

  const handleMonthChange = (programId, yearIndex, monthName, value) => {
    setProgramData((prevData) => {
      const updatedPrograms = prevData.map((program, pIndex) => {
        if (pIndex !== programId) return program;

        const updatedYears = program.years.map((year, yIndex) => {
          if (yIndex !== yearIndex) return year;

          return {
            ...year,
            months: {
              ...year.months,
              [monthName]: value,
            },
          };
        });

        return {
          ...program,
          years: updatedYears,
        };
      });

      return setProgramData(updatedPrograms);
    });
  };
  return (
    <>
      <MainLayout>
        <Loader loading={loading} />
        {unPaid ? (
          <UnPaidCheckout />
        ) : (
          <>
            <Header
              title={"Programs"}
              subTitle={`${programs.length} Program`}
              description={"Manage your programs and preferences here."}
              buttonText={"Add Program"}
              btnOnlcick={openModal}
              className="text-sm sm:text-sm md:text-lg"
            >
              
                    </Header>
                    <div className="overflow-auto w-full ">
                      {programsData?.map((row, programId) => (
                      <div key={programId} className="mb-10  ">
                      {programId > 0 && <hr className="my-5 h-1 bg-gray-500 rounded-full" />}
                        
                        <div className="sm:overflow-x-auto overflow-x-auto">
                        <table className="min-w-full bg-white border border-gray-200 text-xs sm:text-sm md:text-base">
                        <thead>
                          <tr>
                          <th className="px-6 py-3 font-bold border border-gray-205 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-sm xl:text-base text-gray-500 uppercase tracking-wider">
                            Program
                          </th>
                          <th className="px-6 py-3 font-bold border border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-sm xl:text-base text-gray-500 uppercase tracking-wider">
                            Duration
                          </th>
                          <th className="px-6 py-3 font-bold border border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-sm xl:text-base text-gray-500 uppercase tracking-wider">
                            Tuition Amount
                          </th>
                          <th className="px-6 py-3 font-bold border border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-sm xl:text-base text-gray-500 uppercase tracking-wider">
                            Down Payment
                          </th>
                          <th className="px-6 py-3 font-bold border border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-sm xl:text-base text-gray-500 uppercase tracking-wider">
                            Monthly Tuition Fee
                          </th>
                          <th className="px-6 py-3 text-center font-bold border border-gray-200 bg-gray-50  text-xs sm:text-sm md:text-sm lg:text-sm xl:text-base text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          <tr>
                          <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border border-gray-200">
                            <div className="flex flex-row items-center justify-center gap-2">
                            {row?.programName}
                            <button
                              onClick={() => handleEdit(row)}
                              className="text-purple-500 text-lg"
                            >
                              <LuPencilLine />
                            </button>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border border-gray-200">
                            {row?.duration} Months
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border border-gray-200">
                            {formatCurrency(row?.tuitionAmount)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border border-gray-200">
                            {formatCurrency(row?.downPayment)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border border-gray-200">
                            {formatCurrency(
                            (row.tuitionAmount - row.downPayment) / row.duration
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border border-gray-200">
                            <div className="flex flex-col sm:flex-row gap-2">
                            <Button
                              className="py-2 px-4 bg-green-400 rounded-xl hover:bg-green-600"
                              btnOnlcick={() => initiateAddYear(row._id)}
                            >
                              <span className="flex flex-row gap-2 text-white items-center justify-center">
                              <FaPlus /> Year
                              </span>
                            </Button>
                            <Button
                              className="py-2 px-4 bg-blue-400 rounded-xl hover:bg-blue-600"
                              btnOnlcick={() => handleUpdateModal(row._id, true)}
                            >
                              <span className="flex flex-row gap-2 text-white items-center justify-center">
                              <FaEdit /> Update
                              </span>
                            </Button>
                            <Button
                              className="py-2 px-4 bg-red-400 rounded-xl hover:bg-red-600"
                              btnOnlcick={() => handleDelete(row._id)}
                            >
                              <span className="flex flex-row gap-2 text-white items-center justify-center">
                              <FaTrash /> Delete
                              </span>
                            </Button>
                            </div>
                          </td>
                          </tr>
                        </tbody>
                        </table>
                        </div>
                        <div className="overflow-x-auto">
                        <table className="min-w-full bg-white border border-gray-200 text-xs sm:text-sm md:text-base">
                          <thead>
                          <tr>
                            <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-base text-gray-500 uppercase tracking-wider">
                            Year
                            </th>
                            <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-base text-gray-500 uppercase tracking-wider">
                            Name
                            </th>
                            {months.map((month, idx) => (
                            <th
                              key={idx}
                              className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-base text-gray-500 uppercase tracking-wider"
                            >
                              {month}
                            </th>
                            ))}
                            <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs sm:text-sm md:text-sm lg:text-base text-gray-500 uppercase tracking-wider">
                            Total
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          {row.years.map((year, index) => (
                            <tr key={`${row.id}-${index}`}>
                            <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border-b border-gray-200">
                              {year?.year}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border-b border-gray-200">
                              {year?.type}
                            </td>
                            {Object.entries(year.months).map(
                              ([monthName, monthValue], itemId) => (
                              <td
                                key={monthName}
                                className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border-b border-gray-200"
                              >
                                <div className="flex flex-row items-center justify-center gap-2">
                                <input
                                  type="number"
                                  min={0}
                                  value={monthValue}
                                  onChange={(e) =>
                                  handleMonthChange(
                                    programId,
                                    index,
                                    monthName,
                                    parseInt(e.target.value)
                                  )
                                  }
                                  style={{ width: "50px" }}
                                />
                                <button className="text-purple-500 text-lg">
                                  <LuPencilLine />
                                </button>
                                </div>
                              </td>
                              )
                            )}
                            <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-sm lg:text-base text-gray-900 border-b border-gray-200">
                              {Object.values(year?.months).reduce(
                              (total, value) => total + value,
                              0
                              )}
                            </td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                        </div>
                      </div>
                      ))}
                    </div>
              {isModalOpen && (
                <AddProgramModal program={editData} closeModal={closeModal} />
              )}
              <ConfirmDialog
                isOpen={showDeleteDialog}
                title="Confirm Delete"
                message={`Are you sure you want to delete ${programToDelete?.name}?`}
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
              />
              <ConfirmDialog
                isOpen={showAddYearDialog}
                title="Add New Year"
                message={`Do you want to add a new year to this program?`}
                onConfirm={confirmAddYear}
                onCancel={cancelAddYear}
              />
              <ConfirmDialog
                isOpen={update}
                title="Confirm Update"
                message={`Do you want to update this program dates?`}
                onConfirm={confirmUpdate}
                onCancel={cancelUpdate}
              />
            
          </>
        )}
      </MainLayout>
    </>
  );
};

export default StartTracker;

const AddProgramModal = ({ program, closeModal }) => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.auth ?? {});
  const { userId } = userDetails ?? 0;

  const [programData, setProgramData] = useState(
    program || {
      programName: "",
      duration: 1,
      tuitionAmount: 100,
      downPayment: 0,
      values: [
        {
          name: "Projected",
          year: new Date().getFullYear(),
          january: 0,
          february: 0,
          march: 0,
          april: 0,
          may: 0,
          june: 0,
          july: 0,
          august: 0,
          september: 0,
          october: 0,
          november: 0,
          december: 0,
          total: 0,
        },
        {
          name: "Actual",
          year: new Date().getFullYear(),
          january: 0,
          february: 0,
          march: 0,
          april: 0,
          may: 0,
          june: 0,
          july: 0,
          august: 0,
          september: 0,
          october: 0,
          november: 0,
          december: 0,
          total: 0,
        },
      ],
    }
  );

  const handleCreate = (e) => {
    e.preventDefault();
    if (program) {
      const programUpdateInfo = {
        id: program?._id, // Replace with actual userId
        programName: programData?.programName,
        duration: programData?.duration,
        tuitionAmount: programData?.tuitionAmount,
        downPayment: programData?.downPayment,
      };
      dispatch(updateProgram(programUpdateInfo));
      setTimeout(() => {
        dispatch(fetchPrograms(userId));
      }, 1000);
    } else {
      const programInfo = {
        userId: userId, // Replace with actual userId
        programName: programData?.programName,
        duration: programData?.duration,
        tuitionAmount: programData?.tuitionAmount,
        downPayment: programData?.downPayment,
      };
      dispatch(createProgram(programInfo));
      setTimeout(() => {
        dispatch(fetchPrograms(userId));
      }, 1000);
    }

    closeModal();
  };

  // programName, duration, tuitionAmount, downPayment

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-96 ">
        <h2 className="text-lg font-semibold mb-4">
          {program ? "Edit Program" : "Add Program"}
        </h2>
        <div className="flex flex-col w-full gap-5 ">
          <div>
            <label className="block text-sm font-medium text-gray-700 py-1">
              Program Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Program Name"
              value={programData?.programName ?? ""}
              onChange={(e) => {
                setProgramData((prevData) => ({
                  ...prevData,
                  programName: e.target.value,
                }));
              }}
              required
              className="w-full p-2 border-2 border-gray-500 rounded active:outline-purple-200 focus:outline-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 py-1">
              Duration (In Months)
            </label>
            <input
              type="number"
              min={1}
              name="duration"
              placeholder="Duration Month"
              value={programData.duration ?? 0}
              onChange={(e) => {
                setProgramData((prevData) => ({
                  ...prevData,
                  duration: e.target.value,
                }));
              }}
              required
              className=" w-full p-2 border-2 border-gray-500 rounded active:outline-purple-200 focus:outline-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 py-1">
              Tuition Amount (Total)
            </label>
            <input
              type="number"
              name="tutionAmount"
              min={100}
              placeholder="Tuition Amount"
              value={programData.tuitionAmount ?? 0}
              onChange={(e) => {
                setProgramData((prevData) => ({
                  ...prevData,
                  tuitionAmount: e.target.value,
                }));
              }}
              required
              className="w-full p-2 border-2 border-gray-500 rounded active:outline-purple-200 focus:outline-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 py-1">
              Down Payment
            </label>
            <input
              type="number"
              name="downPayment"
              min={0}
              placeholder="Down Payment"
              value={programData.downPayment ?? 0}
              onChange={(e) => {
                setProgramData((prevData) => ({
                  ...prevData,
                  downPayment: e.target.value,
                }));
              }}
              className="w-full p-2 border-2 border-gray-500 rounded"
            />
          </div>
        </div>
        <div className="mt-4 flex justify-end space-x-2">
          <button
            onClick={closeModal}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleCreate}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {program ? "Update" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};
